/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Find Nearest Icon component.
 */
export const SystemFindNearestIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.4998 19.5956C15.8613 19.5956 19.3969 16.06 19.3969 11.6986C19.3969 7.33714 15.8613 3.80151 11.4998 3.80151C7.13841 3.80151 3.60278 7.33714 3.60278 11.6986C3.60278 16.06 7.13841 19.5956 11.4998 19.5956Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M11.4999 15.0128C13.3303 15.0128 14.8142 13.5289 14.8142 11.6985C14.8142 9.86803 13.3303 8.38416 11.4999 8.38416C9.66943 8.38416 8.18555 9.86803 8.18555 11.6985C8.18555 13.5289 9.66943 15.0128 11.4999 15.0128Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M11.4998 3.29963V1' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M11.4998 21.9999V19.7003' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M3.29963 11.5H1' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M21.9998 11.5H19.7002' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default SystemFindNearestIcon;
